import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from '../styles/OrderScreen.module.css';
import { useEffect, useState } from 'react';

export default function Layout({ children, onLogout }) {
  const router = useRouter();
  const [kitchenCode, setKitchenCode] = useState('');

  useEffect(() => {
    setKitchenCode(localStorage.getItem('organizationCode') || '');
  }, []);

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.header__content}>
            <h1 className={styles.header__title}>
              Планшет Адміна: <span>{kitchenCode}</span>
            </h1>
            <button 
              onClick={onLogout}
              className={styles.logoutButton}
            >
              Вийти
            </button>
          </div>
        </div>
      </header>

      <main className={styles.main}>{children}</main>

      <footer className={styles.footer}>
        <div className={styles.container}>
          <nav className={styles.footer__nav}>
            <ul>
              <li>
                <Link href="/" legacyBehavior>
                  <a className={router.pathname === '/' ? styles.active : ''}>
                    Замовлення
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/waiting" legacyBehavior>
                  <a className={router.pathname === '/waiting' ? styles.active : ''}>
                    Очікують
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/in-transit" legacyBehavior>
                  <a className={router.pathname === '/in-transit' ? styles.active : ''}>
                    В дорозі
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/served" legacyBehavior>
                  <a className={router.pathname === '/served' ? styles.active : ''}>
                    Завершені
                  </a>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </footer>
    </div>
  );
}